module.exports = "/images/picture-modify-report.svg?56df9428b6529df107bc6b5381a54c73";